import { GETv1NewsCategory } from '@/api/news';
import { NewsCategory } from '@/constants/categories';

export const getNewsLists = async () => {
  try {
    const res = await GETv1NewsCategory(NewsCategory.FOREX_LIVE);
    return res?.items?.data || [];
  } catch (e) {
    console.log(`新聞跑馬API錯誤`);
    return [];
  }
};
